<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <div class="profile-block">
                <v-layout class="header-menu mb-6" row>
                    <v-flex xs8 class="hotel-name d-inline-flex title-block">
                        Ваш профиль
                    </v-flex>
                    <v-flex class="dashboard">
                        <div
                            class="dashboard__icon"
                            @click="openNotificationList"
                        >
                            <div v-html="require('!html-loader!@/assets/icons/notification_icon.svg')" class="d-inline-flex" />
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout column px-5>
                    <v-flex class="common-text mb-2" v-if="user.last_name || user.first_name">
                        {{user.last_name}} {{user.first_name}}
                    </v-flex>
                    <v-flex class="main-text grey-text mb-4">
                        <span v-if="user.count_homes">{{user.count_homes}} {{user.count_homes_text}}</span>
                        <span v-if="user.count_homes && user.count_devices" class="mr-1">,</span>
                        <span v-if="user.count_devices">{{user.count_devices}} {{user.count_devices_text}}</span>
                    </v-flex>
                    <div class="profile-btn-list">
                        <v-flex class="profile-btn main-text">
                            <v-btn class="btn-dark w-100" @click="openModalChangeName">
                                <div class="d-inline-flex align-center">
                                    <div v-html="require('!html-loader!@/assets/icons/name.svg')" class="img-container mr-2" />
                                    Изменить имя
                                </div>
                                <div class="d-inline-flex">
                                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="rotate-270" />
                                </div>
                            </v-btn>
                        </v-flex>
                        <v-flex class="profile-btn main-text">
                            <v-btn class="btn-dark w-100" @click="openModalChangeEmail">
                                <div class="d-inline-flex align-center">
                                    <div v-html="require('!html-loader!@/assets/icons/email.svg')" class="img-container mr-2" />
                                    Изменить email
                                </div>
                                <div class="d-inline-flex">
                                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="rotate-270" />
                                </div>
                            </v-btn>
                        </v-flex>
                        <v-flex class="profile-btn main-text">
                            <v-btn class="btn-dark w-100" @click="openModalChangePassword">
                                <div class="d-inline-flex align-center">
                                    <div v-html="require('!html-loader!@/assets/icons/password.svg')" class="img-container mr-2" />
                                    Изменить пароль
                                </div>
                                <div class="d-inline-flex">
                                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="rotate-270" />
                                </div>
                            </v-btn>
                        </v-flex>
                        <v-flex class="profile-btn main-text">
                            <v-btn class="btn-dark w-100" @click="openModalChangeTheme">
                                <div class="d-inline-flex align-center">
                                    <div v-html="require('!html-loader!@/assets/icons/color.svg')" class="img-container mr-2" />
                                    Изменить тему
                                </div>
                                <div class="d-inline-flex">
                                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="rotate-270" />
                                </div>
                            </v-btn>
                        </v-flex>
                    </div>
                </v-layout>
            </div>
            <div class="px-5 w-100">
                <v-btn class="btn-dark w-100" @click="confirmLogout">
                    Выйти из профиля
                </v-btn>
            </div>
        </div>
        <ModalMessage
            v-model="modalConfirmLogoutOpen"
            title="Выход из профиля"
            text="Вы точно хотите выйти из профиля?"
            text-btn="Отменить"
            text-confirm-btn="Выйти"
            show-confirm-btn
            text-center
            @confirm="logout"
        />
        <ModalChangeName v-if="modalChangeName" v-model="modalChangeName" :user="user" @update="getUser"/>
        <ModalChangeEmail v-if="modalChangeEmail" v-model="modalChangeEmail" :user="user" @update="getUser"/>
        <ModalChangePassword v-if="modalChangePassword" v-model="modalChangePassword" :user="user.uid"/>
        <ModalChangeTheme v-if="modalChangeTheme" v-model="modalChangeTheme" :user="user.uid"/>
        <ModalWaiting v-model="openModalWaiting"/>
    </v-container>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
import ModalChangeName from "@/components/modals/ModalChangeName";
import ModalChangeEmail from "@/components/modals/ModalChangeEmail";
import ModalChangePassword from "@/components/modals/ModalChangePassword";
import ModalChangeTheme from "@/components/modals/ModalChangeTheme";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {getWord} from "@/utils";
export default {
    name: "ProfilePage",
    components: {ModalMessage, ModalChangeName, ModalChangeEmail, ModalChangePassword, ModalChangeTheme, ModalWaiting},
    data() {
        return {
            modalConfirmLogoutOpen: false,
            modalChangeName: false,
            modalChangeEmail: false,
            modalChangePassword: false,
            modalChangeTheme: false,
            openModalWaiting: false,
            user: {},
        };
    },
    created() {
        this.getUser();
    },
    methods: {
        getUser() {
            this.openModalWaiting = true;
            this.$http.get('/homes/home/profile/')
                .then((response) => {
                    this.user = response.data;
                    this.user.count_homes_text = getWord(this.user.count_homes, ["дом", "дома", "домов"]);
                    this.user.count_devices_text = getWord(this.user.count_devices, ["устройство", "устройства", "устройств"]);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        openNotificationList() {
            this.$router.push({ name: "notificationList" });
        },
        confirmLogout() {
            this.modalConfirmLogoutOpen = true;
        },
        logout() {
            localStorage.removeItem("RobohomeDataAccessToken");
            this.$router.go( 0);
        },
        openModalChangeName() {
            this.modalChangeName = true;
        },
        openModalChangeEmail() {
            this.modalChangeEmail = true;
        },
        openModalChangePassword() {
            this.modalChangePassword = true;
        },
        openModalChangeTheme() {
            this.modalChangeTheme = true;
        },
    },
}
</script>

<style lang="scss">
.profile-block {
    height: calc(100% - 62px);

    .profile-btn {
        display: flex;
        background: var(--dark-black-2);
        box-shadow: 0 2px 15px 0 rgba(37, 37, 37, 0.10);
        border-radius: 0;

        .btn-dark.v-btn {
            justify-content: space-between;
            border-radius: 0;

            .img-container {
                height: 24px;
                width: 24px;
                display: inline-flex;
                align-items: center;
                justify-content: left;
                margin-right: 10px;

                > div {
                    display: inline-flex;
                }
            }
        }

        &:first-child {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;

            .btn-dark.v-btn {
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
            }
        }

        &:last-child {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            .btn-dark.v-btn {
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
            }
        }
    }
}
</style>